import { render } from "./campos-personalizados.vue?vue&type=template&id=048558aa"
import script from "./campos-personalizados.vue?vue&type=script&lang=js"
export * from "./campos-personalizados.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__